export default "__VITE_ASSET__GFBpoQh$__"